// extracted by mini-css-extract-plugin
var _1 = "Actions_root__952cc";
export { _1 as "root" }
